module.exports = __webpack_public_path__ + "img/cards.39b84965.svg";